// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"Hy","delete_item":"Iy","subscription_item":"Jy","subscription_item_img_wrapper":"Ky","subscription_item_info":"Ly","subscription_item_title":"My","subscription_item_edit":"Ny","subscription_item_wrapper":"Oy","arrow":"Py","subscription_item_category":"Qy","plus_button":"Ry","more_details":"Sy","old_price":"Ty","discount":"Uy"};
    if(module.hot) {
      // 1715091678788
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  